import {
    // white,
    pink50,
    pink100,
    pink200,
    pink300,
    pink500,
    grey900,
} from "material-ui/styles/colors";

var PinkTheme = {
    fontFamily: "arial",
    palette : {
        primary1color:      pink500,
        primary2color:      pink300,
        primary3color:      pink100,
        accent1color:       "#E73677",
        accent2color:       "#D0FFCA",
        accent3color:       "#FF9797",
        textColor:          grey900,
        alternateTextColor: pink200, // Button background color.
        canvasColor:        pink50,
    }
};

export default PinkTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/PinkTheme.js
 **/